import { ExpiryDateRecordState } from 'data/__generated__';

export const EXPIRY_DATE_RECORD_STATES_LABELS = {
    [ExpiryDateRecordState.Archived]: 'Archivée',
    [ExpiryDateRecordState.Regular]: 'En cours',
};
